import { nanoid } from "nanoid"



export const skills =[
    {
        id:nanoid(),
        title:"HTML",
        icon: "/assets/icons/html-logo.svg"
    },
    {
        id:nanoid(),
        title:"CSS",
        icon:"/assets/icons/css-logo.svg"
    },
    {
        id:nanoid(),
        title:"JavaScript",
        icon:"/assets/icons/javascript.svg"
    },
    {
        id:nanoid(),
        title:"React" ,
        icon:"/assets/icons/react-js.svg"
    },
    {
        id:nanoid(),
        title:"NodeJS",
        icon: "/assets/icons/nodejs-logo.svg"
    },
    {
        id:nanoid(),
        title:"ExpressJS",
        icon: "/assets/icons/express-logo.svg"
    },
    {
        id:nanoid(),
        title:"Docker",
        icon: "/assets/icons/docker-logo.svg"
    },
    
    {
        id:nanoid(),
        title:"PostgresSQL",
        icon: "/assets/icons/postgres-logo.svg"
    },
    {
        id:nanoid(),
        title:"MySQL",
        icon: "/assets/icons/mysql-logo.svg"
    },
    {
        id:nanoid(),
        title:"MongoDB",
        icon: "/assets/icons/mongodb.png"
    },
    {
        id:nanoid(),
        title:"Bootstrap",
        icon:"/assets/icons/bootstrap-logo.svg"
    },
    {
        id:nanoid(),
        title:"Tailwind",
        icon:"/assets/icons/tailwindcss.svg"
    },
    {
        id:nanoid(),
        title:"React Router v6",
        icon:"/assets/icons/react-router.svg"
    },
    {
        id:nanoid(),
        title:"Redux",
        icon:"/assets/icons/redux.svg"
    },

    {
        id:nanoid(),
        title:"Git",
        icon:"/assets/icons/git-logo.svg"
    },
    {
        id:nanoid(),
        title:"GitHub",
        icon:"/assets/icons/github-logo-80.png"
    },
    {
        id:nanoid(),
        title:"npm",
        icon:"/assets/icons/npm-logo.svg"
    },
    {
        id:nanoid(),
        title:"VSCode",
        icon:"/assets/icons/visual-studio-code-2019.svg"
    }

]